// import tagsLoader from '@/mixins/spawner/loaders/orm/tags-loader';
// import schemasLoader from '@/mixins/spawner/loaders/schemas-loader';

export default {

  data() {
    return {
      debug: this.$store.get('debug/orm@debug'),
      showCount: this.$store.get('debug/orm@showCount'),
    };
  },

  mixins: [
    // tagsLoader,
    // schemasLoader,
  ],

  methods: {
    loadSpawnerCache(fromDb) {
      /* ORM */
      // this.loadTags(fromDb);
      /* ORM */
      /* DB */
      // this.loadSchema('nav');
      // this.loadSchema('filters');
      /* DB */
    },
  },

  mounted() {
    this.loadSpawnerCache(false);

    Bus.$on('refresh_cache', () => {
      this.loadSpawnerCache(true);
    });
  },

  beforeDestroy() {
    Bus.$off('refresh_cache');
  },
};
